import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import AuthUser from "../AuthUser";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../Spinner";

import Swal from "sweetalert2";

import { startOfMonth, endOfMonth, format } from "date-fns";

const ColaboradorDobraNaEscalaModal = ({
  escala_id,
  colaborador,
  onSubmissionSuccess,
  colaboradores,
  dia,
}) => {
  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user,
    user_permissoes,
    verificarPermissao,
    getMissao,
  } = AuthUser();

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [tipoMarcacao, setTipoMarcacao] = useState(1);
  const [remuneracao, setRemuneracao] = useState(1);
  const [nota, setNota] = useState('');

  const [colaborador_id, setColaborador] = useState(-1);

  const toggleLoading = (value) => {
    setLoading(value);
  };

  useEffect(() => {
    const currentDate = new Date();
    setData(format(currentDate, "yyyy-MM-dd"));
  }, [colaborador]);

  // REGISTO NOVO

  const marcar_alteracao = async () => {
    try {
      toggleLoading(true);
      await registar();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Show a error toast
        toast.error("Utilizador não autenticado.", {
          position: "top-right",
          autoClose: 3000, // Close the toast after 3 seconds
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
      } else {
        // Show a error toast
        toast.error(
          "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde. Verifique tambem se o e-mail ja esta registado",
          {
            position: "top-right",
            autoClose: 3000, // Close the toast after 3 seconds
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          }
        );
      }
    } finally {
      toggleLoading(false);
    }
  };

  const triggerCloseButtonClick = (buttonId) => {
    const closeButton = document.getElementById(buttonId);
    if (closeButton) {
      closeButton.dispatchEvent(new Event("click"));
    }
  };

  const registar = async () => {


    if(dia?.id != 0 && ( (tipoMarcacao==1 && colaborador_id!=colaborador?.id && colaborador_id!=0 && colaborador_id!=-1) || tipoMarcacao!=-1  ) ){

      try {

        setLoading(true);
  
        const formData = new FormData();
        formData.append("escala_id", escala_id);
        formData.append("dia_id", dia?.id);
        formData.append("colaborador_id", colaborador?.id);
        formData.append("dobrante_id", colaborador_id);
        formData.append("tipo", tipoMarcacao);
        formData.append("nota", nota);
        formData.append("remuneracao", remuneracao);
  
        const response = await http.post(
          "/escala/colaborador/alterar/dobra",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
  
        setLoading(false);

        Swal.fire({
          title: "Sucesso",
          text: "Troca registada com sucesso!",
          type: "error",
          showCancelButton: !0,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Certo, entendi!",
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-danger ml-1",
          buttonsStyling: !1,
        });
  
        if (response?.data) {
          onSubmissionSuccess(response);
          triggerCloseButtonClick("closeButton6");
        }
      } catch (error) {
        toast.error(
          "Ocorreu um erro ao carregar o utilizador. Por favor, tente novamente mais tarde.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          }
        );
      }

    }else{

      toast.error(
        "Dia ou colaborador dobrante invalido.",
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        }
      );
    }

  };

  const renderOptionColaboradores = (colaboradores) => {
    return colaboradores?.map((colaborador) => (
      <React.Fragment key={colaborador?.id}>
        <option value={colaborador?.id}>
          {colaborador?.name} - {colaborador?.cargo?.designacao}
        </option>
      </React.Fragment>
    ));
  };

  return (
    <>
      {/* Personal Info Modal */}
      <div
        id="escala_dobra_colaborador_modal"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="fa fa-calendar" /> Registar dobra ou troca  para -{" "}
                {colaborador?.name}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeButton6"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row justify-content-center">
                      <div className="col-md-4">
                        <div className="input-block mb-3 mb-3 form-focus focused">
                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={dia?.dia + "-" + dia?.mes + "-" + dia?.ano}
                              readOnly={true}
                            />
                            <label className="focus-label">
                              {t("Data Da Dobra | Troca")}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="input-block mb-3 mb-3 form-focus focused">
                          <select
                            className="form-control select"
                            onChange={(e) => setTipoMarcacao(e.target.value)}
                          >
                            <option value="1">Registar</option>
                            <option value="0">Remover</option>
                          </select>

                          <label className="focus-label">
                            {t("Registar Ou Remover Dobra | Troca")}{" "}
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>

                      <div className="col-md-10">
                        <div className="input-block form-focus select-focus">
                          <label className="focus-label">{t("Dobrante | Substituto")}</label>
                          <select
                            onChange={(e) => setColaborador(e.target.value)}
                            value={colaborador_id}
                            className="form-control select"
                          >
                            <option key={0} value={-1}>
                              -
                            </option>
                            {renderOptionColaboradores(colaboradores)}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-10">
                        <div className="input-block mb-3 mb-3 form-focus focused">
                          <select
                            className="form-control select"
                            onChange={(e) => setRemuneracao(e.target.value)}
                          >
                            <option value="1">Sem remuneração ao Ausente (falta injustificavel )</option>
                            <option value="2">Com remuneração ao Ausente ( falta justificavel )</option>
                            <option value="3">Sem remuneração adicional  ao substituto ( troca por reserva | outro )</option>
                            <option value="4">Com remuneração adicional ao substituto ( compensar a dobra )</option>
                            <option value="5">Sem remuneração a ambos ( troca por reserva e falta injustificavel )</option>
                            <option value="6">Com remuneração a ambos ( dobra e falta justificavel)</option>
                           
                          </select>

                          <label className="focus-label">
                            {t("Definir ou não remuneração para o ausente")}{" "}
                            <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>

                      <div className="col-md-10">
                        <div className="input-block mb-3 mb-3 form-focus focused">
                          <div>
                            <input
                              className="form-control"
                              type="text"
                              value={nota}
                              onChange={(e) => setNota(e.target.value)}
                            />
                            <label className="focus-label">
                              {t("Nota")}
                            </label>
                          </div>
                        </div>
                      </div>

                      
                    </div>

                    <div className="submit-section m-t-20 text-center">
                      <a
                        className="btn btn-primary submit-btn"
                        onClick={marcar_alteracao}
                      >
                        {t("Salvar")}
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Personal Info Modal */}

      <ToastContainer />

      {loading ? (
        <>
          <Spinner></Spinner>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ColaboradorDobraNaEscalaModal;
